import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { SnSize } from '@lib/common/types';

@Component({
  selector: 'sn-camera-record-status',
  templateUrl: './camera-record-status.component.html',
  styleUrls: ['./camera-record-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SnCameraRecordStatusComponent implements OnInit {
  @Input()
  public record = false;

  @Input()
  public size: SnSize = 'sm';

  constructor() {}

  public ngOnInit(): void {}
}
